/**
 * Parse a datetime string from the backend.
 * Backend SQLAlchemy returns naive UTC timestamps (no `Z`), so we explicitly
 * append the UTC marker before handing to `new Date()` — otherwise browsers
 * interpret the string as local time and compute "X ago" wildly wrong.
 */
export function parseUtc(value) {
    if (value == null) return null;
    if (value instanceof Date) return value;
    let s = String(value);
    if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(s)) {
        s = s + "Z";
    }
    const d = new Date(s);
    return Number.isNaN(d.getTime()) ? null : d;
}

/** Human-friendly "X ago" for a UTC timestamp string. */
export function timeAgo(value) {
    const d = parseUtc(value);
    if (!d) return "—";
    const mins = Math.round((Date.now() - d.getTime()) / 60000);
    if (mins < 1) return "just now";
    if (mins < 60) return `${mins} min ago`;
    const hours = Math.round(mins / 60);
    if (hours < 24) return `${hours} h ago`;
    const days = Math.round(hours / 24);
    return `${days} d ago`;
}
